import { useQuery } from "react-query";
import axios from "axios";
import https from "https";
import log from "../../utils/log";
import metaData from "../../data/metaData";
import useAuthStore from "../../states/useAuth";
import { getProductAvailableQty } from "../../utils/product";
import useDB from "../useDB";

const useReferral = (type = "referrals", params = {}, options = {}) => {
  const { user, auth } = useAuthStore();
  const { get } = useDB();

  // Default query options
  const defaultOptions = {
    enabled: !!user?.companyId, // Only enable if companyId is available
    staleTime: 10000,
    // onSuccess: (data) => log.debug(data),
    onError: (error) => log.error(error),
    // select: type === "codes" ? (data) => data.map((e, i) => ({ key: i, ...e })) : undefined,
    keepPreviousData: true,
  };

  // Merge default options with user-provided options
  const queryOptions = { ...defaultOptions, ...options };

  // Define the query function
  const fetchReferralData = async () => {
    // Determine the endpoint and default parameters based on the type
    const endpoint = type === "referral" ? "referral/query" : "referrals/query";
    const requestData = {
      companyId: user.companyId,
      populate: [
        {
          path: "company",
          select: "brandId",
          populate: {
            path: "brand",
            select: "name logo",
          },
        },
        {
          path: "referrerProductsDetail",
          select: "name gallery",
        },
        {
          path: "refereeProductsDetail",
          select: "name gallery",
        },
      ],
      ...params, // Merge custom params
    };

    log.debug(`fetch POST/${endpoint}`);
    const result = await get(endpoint, requestData);

    // Optionally filter products based on availability
    if (options.filterAvailableQty) {
      return result.filter((product) => {
        const availableQty = getProductAvailableQty(product.qty); // Calculate available quantity
        return availableQty > 0; // Keep only products with available quantity greater than 0
      });
    }

    return result;
  };

  return useQuery([type, params], fetchReferralData, queryOptions);
};

export default useReferral;
